const GET_PROFILE_INFO = 'GET_PROFILE_INFO';
const GET_PROFILE_TAB_DATA = 'GET_PROFILE_TAB_DATA';

export default {
  GET_PROFILE_INFO,
  GET_PROFILE_TAB_DATA,
};
